module.exports = __webpack_public_path__ + "static/media/wheelchair.ade2deff.svg";